// Copyright 2021-2024, 2026 - Hewlett Packard Enterprise Company

import { AuthConsumer } from '../contexts/AuthContext';

export default function Logout() {
  return (
    <AuthConsumer>
      {({ logout }) => {
        logout();
        return null;
      }}
    </AuthConsumer>
  );
}
